// removed by extract-text-webpack-plugin
module.exports = {"search-box":"SurveyStudentSearch__search-box___3KYja","confirm-button":"SurveyStudentSearch__confirm-button___1FbtV"};